import React from 'react';
import './MenuCard.css';

export type MenuCardProps = {
	section: string
    link: string
    image?: string
    x?: number
    y?: number
    zoom?: number
}

export const MenuCard: React.FC<MenuCardProps> = ({
	section,
    link,
	image,
    x,
    y,
    zoom,
}) => {
    console.log(x)
	return (
            <div className='menucard'>
                <a href={link} target='_blank'>
                <div className='menucard-background'
                        style={{
                            background: `url(${image}) no-repeat`,
                            backgroundPosition: (typeof x === 'number' &&
                                    typeof y === 'number') ? `${x}% ${y}%` : 'center',
                            backgroundSize: (typeof zoom === 'number') ? zoom + "%" : 'cover'
                            }}>
                        <h3 className='title'>{section}</h3>
                </div>
                </a>
            </div>
    )
}